// Add this new component to your existing file or create a new one
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import FormInputWithLabel from '../../Components/Global_Components/form/FormInputWithLabel';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {renderDynamicTable} from '../../utils/templateUtils';
import './stimulation_template.scss';

export default function StimulationTemplate(props) {
  const [formData, setFormData] = useState({
    startingDay: '',
    procedure: '',
    stimulationNo: '',
    additionalProcedure: '',
    stimulationProtocol: '',
    previousTreatment: '',
    femaleFactors: [],
    maleFactors: []
  });

  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [showTables, setShowTables] = useState({
    femaleMedication: true,
    maleMedication: true,
    follicularMonitoring: true,
    injection: true
  });

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  const procedures = ['Self ICSI', 'H/DONOR ICSI H', 'DONOR ICSI D'];

  const additionalProcedures = ['Microfluidics', 'PICSI', 'PGT A'];

  const stimulationProtocols = ['agonist', 'antagonist', 'antagonist stop', 'PPOS', 'random start', 'DUAL STIMULATION'];

  const previousTreatments = ['ICSI', 'IUI', 'IVF'];

  const startingDays = ['DAY2', 'DAY3', 'DAY4'];

  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };

  const [femaleMedicationRows, setFemaleMedicationRows] = useState([
    {
      sno: '1',
      drug: 'QCoComplex / UltraQ300',
      genericName: 'Coenzyme Q10 300mg',
      dose: '300mg',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '10 Days'
    },
    {
      sno: '2',
      drug: 'Tab. Folvista',
      genericName: 'L-Methylfolate + Myo-Inositol + D-Chiro-Inositol + B12',
      dose: '-',
      freq: '0-0-1',
      withFood: 'After food',
      duration: '10 Days'
    },
    {
      sno: '3',
      drug: 'Tab. Clomiphene',
      genericName: 'Clomiphene Citrate 100 mg',
      dose: '100mg',
      freq: '1-0-0',
      withFood: 'After food',
      duration: '5 Days'
    },
    {
      sno: '4',
      drug: 'Tab. Meparate',
      genericName: 'Medroxyprogesterone Acetate 10 mg',
      dose: '10mg',
      freq: '1-0-0',
      withFood: 'After food',
      duration: 'Till trigger day'
    }
  ]);

  const [maleMedicationRows, setMaleMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Tab. Ferpill Max',
      genericName: 'L-Carnitine, Coenzyme Q10, Lycopene, Zinc, Selenium, B12',
      dose: '_',
      freq: '0-0-1',
      withFood: 'After',
      duration: '10 days'
    },
    {
      sno: '2',
      drug: 'Tab. UltraQ 300 / QCoComplex',
      genericName: 'Coenzyme Q10 300 mg',
      dose: '300 mg',
      freq: '1-0-1',
      withFood: 'After',
      duration: '10 days'
    },
    {
      sno: '3',
      drug: 'Tab. Doxy LB',
      genericName: 'Doxycycline 100 mg + Lactobacillus spores',
      dose: '100 mg',
      freq: '1-0-1',
      withFood: 'After',
      duration: '10 days'
    },
    {
      sno: '4',
      drug: 'Tab. PAN',
      genericName: 'Pantoprazole 40 mg',
      dose: '40 mg',
      freq: '1-0-1',
      withFood: 'Before',
      duration: '14 days'
    }
  ]);

  const [injectionRows, setInjectionRows] = useState([
    {
      injection: 'FOLLISURGE',
      route: '',
      dose: ''
    },
    {
      injection: 'MENOTAS',
      route: '',
      dose: ''
    },
    {
      injection: 'HUMOG',
      route: '',
      dose: ''
    },
    {
      injection: 'PERGOVERIS',
      route: '',
      dose: ''
    },
    {
      injection: 'GONAL',
      route: '',
      dose: ''
    },
    {
      injection: 'MENOPUR',
      route: '',
      dose: ''
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug Name (Brand)'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dose', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'withFood', label: 'With Food?'},
    {key: 'duration', label: 'Duration'}
  ];
  const injectionHeaders = [
    {key: 'injection', label: 'INJECTIONS'},
    {key: 'route', label: 'ROUTE'},
    {key: 'dose', label: 'DOSE'}
  ];

  const follicularMonitoringHeaders = [
    {key: 'date', label: 'DATE', inputType: 'date'},
    {key: 'day', label: 'DAY'},
    {key: 'rightOvary', label: 'RIGHT OVARY'},
    {key: 'leftOvary', label: 'LEFT OVARY'},
    {key: 'endometrialThickness', label: 'ENDOMETRIAL THICKNESS'}
  ];

  const [follicularMonitoringRows, setFollicularMonitoringRows] = useState([
    {date: '', day: 'S5', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S6', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S7', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S8', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S9', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S10', rightOvary: '', leftOvary: '', endometrialThickness: ''},
    {date: '', day: 'S11', rightOvary: '', leftOvary: '', endometrialThickness: ''}
  ]);

  let femalebmiValue = formData?.femaleHeight && formData?.femaleWeight ? ((formData.femaleWeight / formData.femaleHeight ** 2) * 10000).toFixed(2) : '';
  let malebmiValue = formData?.maleHeight && formData?.maleWeight ? ((formData.maleWeight / formData.maleHeight ** 2) * 10000).toFixed(2) : '';

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        p_uhid: props.patientsData.p_uhid
      };
      props.loaderchange('true');
      const addPatient = fetchPatientDetailsUuid(payload);
      const response = await dispatch(addPatient);
      if (response.payload?.status?.code === 200) {
        const data1 = response.payload.data.data[0].gender == 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
        const data2 = response.payload.data.data[0].gender == 'Female' ? response.payload.data.data[0] : response.payload.data.data[1];
        const namePat1 = data1?.titles + ' ' + data1?.first_name + ' ' + data1?.last_name;
        const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;

        setPatientOne_UUId(data1?.id);
        setFormData({
          ...formData,
          patientName1: namePat1,
          age1: data1?.age,
          gender1: data1?.gender,
          patientId1: data1?.p_uhid,

          patientName2: namePat2,
          age2: data2?.age,
          gender2: data2?.gender,
          patientId2: data2?.p_uhid
        });
        props.loaderchange('false');
      }
      return;
    };

    fetchData();
  }, []);

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (type, value) => {
    setFormData(prev => {
      const currentFactors = prev[type];
      if (currentFactors.includes(value)) {
        return {
          ...prev,
          [type]: currentFactors.filter(item => item !== value)
        };
      } else {
        return {
          ...prev,
          [type]: [...currentFactors, value]
        };
      }
    });
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;
    return (
      <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
        <label style={{...styleLabel, fontWeight: '600', marginRight: '5px', width: 'max-content'}}>{name}</label>
        <span style={styleSpan}>{value}</span>
      </section>
    );
  };

  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };

  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };

  const handlesubmit = () => {
    try {
      if (patientOne_UUId !== '' && formData.patientId1 !== '' && formData.patientId1.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('stimulationTemplateReportWrap').innerHTML;
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Stimulation Template'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='StimulationTemplate'>
      <div className='StimulationTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div className='row'>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId1' value={formData.patientId1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName1' value={formData.patientName1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender1}
                    name='gender1'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender1}</span>
                </div>
                <FormInputWithLabel label='Age' name='age1' value={formData.age1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId2' value={formData.patientId2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName2' value={formData.patientName2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender2}
                    name='gender2'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender2}</span>
                </div>
                <FormInputWithLabel label='Age' name='age2' value={formData.age2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
            </div>
          </div>
        </div>
        <p class='Dani'></p>

        {/* Treatment Plan Section */}
        <div className='detail mt-4'>
          <h3>STIMULATION -- STARTING TEMPLATE</h3>

          <div className='row mt-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='AFC :' name='AFC' value={formData.AFC} required={false} onChange={handleChange} inputClassName='show' />
            </div>

            <div className='col-md-4'>
              <ReportFormInputWithLabel label='AMH :' name='AMH' value={formData.AMH} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='DFI :' name='DFI' value={formData.DFI} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='SA :' name='SA' value={formData.SA} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='COMORBIDE - MALE :'
                name='comorbideMale'
                value={formData.comorbideMale}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='200px'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='COMORBIDE - FEMALE :'
                name='comorbideFemale'
                value={formData.comorbideFemale}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='220px'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <label className='me-2 mt-3 fw-bold' style={{minWidth: '150px'}}>
                STARTING DAY:
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='startingDay' value={formData.startingDay} onChange={handleChange}>
                <option value='' disabled>
                  Select Day
                </option>
                {startingDays.map(day => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <h3 className='mt-4'>Treatment Plan:</h3>

          <div className='row'>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Procedure:
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='procedure' value={formData.procedure} onChange={handleChange}>
                <option value='' disabled>
                  Select Procedure
                </option>
                {procedures.map(proc => (
                  <option key={proc} value={proc}>
                    {proc}
                  </option>
                ))}
              </select>
            </div>

            <div className='col-md-3'>
              <label className='fw-bold me-2'>STIMULATION NO:</label>
              <input type='number' className={`createTime ${show ? 'hide' : 'show'}`} name='stimulationNo' value={formData.stimulationNo} onChange={handleChange} min='1' max='10' />
            </div>

            <div className='col-md-5 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Additional Procedure:
              </label>
              <select className={`createTime fw-bold${show ? 'hide' : 'show'}`} name='additionalProcedure' value={formData.additionalProcedure} onChange={handleChange}>
                <option value='' disabled>
                  Select
                </option>
                {additionalProcedures.map(proc => (
                  <option key={proc} value={proc}>
                    {proc}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className='row mt-3'>
            <div className='col-md-6 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Stimulation Protocol:
              </label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='stimulationProtocol' value={formData.stimulationProtocol} onChange={handleChange}>
                <option value='' disabled>
                  Select Protocol
                </option>
                {stimulationProtocols.map(protocol => (
                  <option key={protocol} value={protocol}>
                    {protocol}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {/* Previous Treatment History */}
        <div className='detail mt-4'>
          <div className='row'>
            {/* <div className='col-md-6 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Stimulation Protocol:
              </label> */}
            <div className='col-md-8 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Previous Treatment History:
              </label>
              {/* <h3>Previous Treatment History:</h3> */}
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='previousTreatment' value={formData.previousTreatment} onChange={handleChange}>
                <option value='' disabled>
                  Select Previous Treatment
                </option>
                {previousTreatments.map(treatment => (
                  <option key={treatment} value={treatment}>
                    {treatment}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className='row mt-2'>
          <h4 className='mt-4'>FEMALE INFORMATION</h4>

          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Height :' name='femaleHeight' value={formData.femaleHeight} required={false} onChange={handleChange} inputClassName='show' endLabel='cm' />
          </div>

          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Weight :' name='femaleWeight' value={formData.femaleWeight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
          </div>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='BMI :' name='fbmi' value={femalebmiValue} required={false} onChange={handleChange} inputClassName='show' endLabel='kg/m2' />
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='PR :' name='femalePulse' value={formData.femalePulse} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel
              label='Blood Pressure (BP) :'
              name='femaleBP'
              value={formData.femaleBP}
              required={false}
              onChange={handleChange}
              inputClassName='show'
              endLabel='mmHg'
              minWidth='200px'
            />
          </div>
        </div>
        <div className='row mt-2'>
          <h4>MALE INFORMATION</h4>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Height :' name='maleHeight' value={formData.maleHeight} onChange={handleChange} show={true} endLabel='cm' />
          </div>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Weight :' name='maleWeight' value={formData.maleWeight} onChange={handleChange} show={true} endLabel='kg' />
          </div>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='BMI :' name='maleBMI' value={malebmiValue} onChange={handleChange} show={true} endLabel='kg/m2' />
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='PR :' name='malePR' value={formData.malePR} onChange={handleChange} show={true} endLabel='bpm' />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='Blood Pressure (BP)  :' name='maleBP' value={formData.maleBP} onChange={handleChange} show={true} endLabel='mmHg' minWidth='200px' />
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-md-6 fw-bold' style={{fontSize: '18px'}}>
            <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
              Female Factor:
            </label>
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='femaleFactors' value={formData.femaleFactors} onChange={handleChange}>
              <option value='' disabled>
                Select Female Factor
              </option>
              <option value='PCOS'>PCOS</option>
              <option value='Low Ovarian Reserve (AMH &lt; 1.5 ng/mL)'>Low Ovarian Reserve (AMH &lt; 1.5 ng/mL)</option>
              <option value='Tubal Factor'>Tubal Factor</option>
              <option value='Endometriosis'>Endometriosis</option>
              <option value='Unexplained Infertility'>Unexplained Infertility</option>
              <option value='Recurrent Pregnancy Loss (RPL)'>Recurrent Pregnancy Loss (RPL)</option>
              <option value='Premature Ovarian Insufficiency (POI)'>Premature Ovarian Insufficiency (POI)</option>
              <option value='Normal'>NORMAL</option>
              <option value='Fibroids'>FIBROIDS</option>
            </select>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-6 fw-bold' style={{fontSize: '18px'}}>
            <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
              Male Factor:
            </label>
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='maleFactors' value={formData.maleFactors} onChange={handleChange}>
              <option value='' disabled>
                Select Male Factor
              </option>
              <option value='Oligoasthenoteratozoospermia (OAT)'>Oligoasthenoteratozoospermia (OAT)</option>
              <option value='Severe OAT (SOAT)'>Severe OAT (SOAT)</option>
              <option value='High DNA Fragmentation Index (DFI)'>High DNA Fragmentation Index (DFI)</option>
              <option value='Azoospermia'>Azoospermia</option>
              <option value='NORMAL'>NORMAL</option>
            </select>
          </div>
        </div>

        {/* Medications */}
        {showTables.femaleMedication && (
          <div className='detail mt-4'>
            <TemplateTable
              id='femaleMedication'
              title='Prescribed Medications – Female Partner:'
              headers={medicationHeaders}
              rows={femaleMedicationRows}
              onRowsChange={(id, newRows) => setFemaleMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('femaleMedication')}
            />
          </div>
        )}
        {showTables.maleMedication && (
          <div className='detail mt-4'>
            <TemplateTable
              id='maleMedication'
              title='Prescribed Medications – Male Partner:'
              headers={medicationHeaders}
              rows={maleMedicationRows}
              onRowsChange={(id, newRows) => setMaleMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('maleMedication')}
            />
          </div>
        )}
        {/* Important Instructions */}
        <div className='detail mt-4'>
          <h3>⚠️ Important Instructions:</h3>
          <ul>
            <li>
              <strong>Storage of Injections:</strong> If carrying injections home, <strong>store in fridge SECOND/THIRD TRAY</strong>. Responsibility rests with you.
            </li>
            <li>
              <strong>Consent & Financial Counseling:</strong> To be completed
            </li>
            <li>
              <strong>Semen Freezing:</strong> By <strong>Day 5/6</strong> of stimulation at the planned center.
            </li>
            <li>
              <strong>Hormonal Monitoring:</strong> E2/LH on Day 2, Day 5/6, and on <strong>Trigger Day</strong>.
            </li>
            <li>
              <strong>Injection Payment:</strong> AS PER ACTUALS
            </li>
          </ul>

          <p className='mt-3'>
            <strong>Injection Timing:</strong> Administer injections <strong>at clinic or home between 9-11 AM</strong>
          </p>

          {showTables.injection && (
            <div className='detail mt-4'>
              <TemplateTable
                id='injection'
                title=''
                headers={injectionHeaders}
                rows={injectionRows}
                onRowsChange={(id, newRows) => setInjectionRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('injection')}
              />
            </div>
          )}
        </div>
        {/* Follicular Monitoring Sheet */}
        {showTables.follicularMonitoring && (
          <div className='detail mt-4'>
            <TemplateTable
              id='follicularMonitoring'
              title='Follicular Monitoring Sheet:'
              headers={follicularMonitoringHeaders}
              rows={follicularMonitoringRows}
              onRowsChange={(id, newRows) => setFollicularMonitoringRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('follicularMonitoring')}
            />
          </div>
        )}

        <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' />
        </p>
        {/* Footer and Submit Button */}
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      {/* Report Generation Section */}
      {/* Report Generation Section */}
      <div id='generateStimulationTemplateReport'>
        <div id='stimulationTemplateReportWrap'>
          <Headers />
          <p class='Dani'></p>
          {/* Patient Information */}
          <div className='firstPartner' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '10px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>

          <div className='secondPartner' style={{border: '1px solid black', borderRadius: '10px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>

          {/* Treatment Plan */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>STIMULATION -- STARTING TEMPLATE</h4>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('AFC:', formData.AFC, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('AMH:', formData.AMH, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('DFI:', formData.DFI, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('SA:', formData.SA, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('COMORBIDE - MALE:', formData.comorbideMale, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('COMORBIDE - FEMALE:', formData.comorbideFemale, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}

              {renderReportfield('STARTING DAY:', formData.startingDay, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}
            </div>

            <h5 style={{fontWeight: 600, marginTop: '15px', color: '#444'}}>Treatment Plan:</h5>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('Procedure:', formData.procedure, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}
              {renderReportfield('STIMULATION NO:', formData.stimulationNo, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}
              {renderReportfield('Additional Procedure:', formData.additionalProcedure, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}
              {renderReportfield('Stimulation Protocol:', formData.stimulationProtocol, {
                styleSec: {margin: '5px 0'},
                styleLabel: {fontWeight: 600, minWidth: '120px'}
              })}
            </div>

            <h5 style={{fontWeight: 600, marginTop: '15px', color: '#444'}}>Previous Treatment History:</h5>
            <div style={{marginLeft: '20px'}}>{formData.previousTreatment}</div>
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>FEMALE INFORMATION</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.femaleHeight ? formData.femaleHeight : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.femaleWeight ? formData.femaleWeight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${femalebmiValue ? femalebmiValue : ''} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('PR :', `${formData.femalePulse ? formData.femalePulse : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Blood Pressure (BP) :', `${formData.femaleBP ? formData.femaleBP : ''} mm Hg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{display: 'flex', marginTop: '20px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>MALE INFORMATION</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.maleHeight ? formData.maleHeight : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.maleWeight ? formData.maleWeight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${malebmiValue ? malebmiValue : ''} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('PR :', `${formData.malePR ? formData.malePR : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Blood Pressure (BP) :', `${formData.maleBP ? formData.maleBP : ''} mmHg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          {/* Factors */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{display: 'flex', gap: '30px'}}>
              <div style={{flex: 1}}>
                <h5 style={{fontWeight: 600, marginBottom: '10px'}}>♀ Female Factor(s):</h5>
                <div style={{marginLeft: '20px'}}>{formData.femaleFactors ? formData.femaleFactors : 'No factors selected'}</div>
              </div>

              <div style={{flex: 1}}>
                <h5 style={{fontWeight: 600, marginBottom: '10px'}}>♂ Male Factor(s):</h5>
                <div style={{marginLeft: '20px'}}>{formData.maleFactors ? formData.maleFactors : 'No factors selected'}</div>
              </div>
            </div>
          </div>

          {/* Medications */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            {showTables.femaleMedication && (
              <>
                <h5 style={{fontWeight: 600, marginBottom: '15px'}}>💊 Prescribed Medications -- Female Partner</h5>
                <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginBottom: '20px'}}>
                  <thead>
                    <tr>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>S.NO</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DRUG NAME (BRAND)</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>GENERIC NAME</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DOSE</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>FREQUENCY</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>WITH FOOD</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DURATION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {femaleMedicationRows.map((med, index) => (
                      <tr key={index}>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.sno}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.drug}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.genericName}</td>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.dose}</td>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.freq}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.withFood}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
            {showTables.maleMedication && (
              <>
                <h5 style={{fontWeight: 600, marginBottom: '15px'}}>💊 Male Partner -- Prescribed Medications</h5>
                <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginBottom: '20px'}}>
                  <thead>
                    <tr>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>S.NO</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DRUG NAME (BRAND)</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>GENERIC NAME</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DOSE</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>FREQUENCY</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>WITH FOOD</th>
                      <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DURATION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {maleMedicationRows.map((med, index) => (
                      <tr key={index}>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.sno}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.drug}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.genericName}</td>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.dose}</td>
                        <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{med.freq}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.withFood}</td>
                        <td style={{border: '1px solid black', padding: '8px'}}>{med.duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>

          {/* Important Instructions */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '10px'}}>⚠️ Important Instructions:</h5>
            <div className='row'>
              <div className='col-12 mb-2'>
                <strong>Storage of Injections:</strong> If carrying injections home, <strong>store in fridge SECOND/THIRD TRAY</strong>. Responsibility rests with you.
              </div>
              <div className='col-12 mb-2'>
                <strong>Consent & Financial Counseling:</strong> To be completed
              </div>
              <div className='col-12 mb-2'>
                <strong>Semen Freezing:</strong> By <strong>Day 5/6</strong> of stimulation at the planned center.
              </div>
              <div className='col-12 mb-2'>
                <strong>Hormonal Monitoring:</strong> E2/LH on Day 2, Day 5/6, and on <strong>Trigger Day</strong>.
              </div>
              <div className='col-12 mb-2'>
                <strong>Injection Payment:</strong> AS PER ACTUALS
              </div>
            </div>
            <p style={{marginTop: '15px', fontWeight: 600}}>
              <strong>Injection Timing:</strong> Administer injections <strong>at clinic or home between 9–11 AM</strong>
            </p>

            {showTables.injection && renderDynamicTable('', ['INJECTIONS', 'ROUTE', 'DOSE'], ['injection', 'route', 'dose'], injectionRows)}
          </div>

          {/* Follicular Monitoring Sheet */}
          {showTables.follicularMonitoring && (
            <div style={{marginTop: '20px', marginBottom: '40px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>🧾 Follicular Monitoring Sheet</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DATE</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>DAY</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>RIGHT OVARY</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>LEFT OVARY</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>ENDOMETRIAL THICKNESS</th>
                  </tr>
                </thead>
                <tbody>
                  {follicularMonitoringRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.date || '-'}</td>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.day}</td>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.rightOvary || '-'}</td>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.leftOvary || '-'}</td>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.endometrialThickness || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>

          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
